// @ts-nocheck
import { NavLink, useLocation } from 'react-router-dom'
import { LayoutDashboard, Phone, Users, Settings, LogOut, PhoneCall, UserSquare, UserCircle, BarChart3, MessageCircle } from 'lucide-react'
import { useLineChatStore } from '../stores/lineChatStore'
import { useAuthStore } from '../stores/authStore'

/**
 * レイアウトのサイドバーコンポーネント
 * - ナビゲーションメニュー
 * - ユーザー情報
 * - ログアウトボタン
 */
export default function LayoutSidebar({ sidebarOpen, user, logout }) {
  const location = useLocation()
  const lineUnreadCount = useLineChatStore(state => state.totalUnreadCount)
  const isAdmin = useAuthStore(state => state.isAdmin())
  const roleLabel = isAdmin ? '管理者' : 'オペレーター'

  const navigationSections = [
    {
      label: '業務',
      items: [
        { name: 'ダッシュボード', to: '/', icon: LayoutDashboard },
        { name: '着信キュー', to: '/queue', icon: PhoneCall },
        { name: '通話履歴', to: '/call-history', icon: Phone },
        { name: '顧客管理', to: '/customers', icon: UserCircle },
        { name: 'LINE チャット', to: '/line-chat', icon: MessageCircle },
        { name: '統計・レポート', to: '/statistics', icon: BarChart3 },
      ],
    },
    {
      label: '管理・設定',
      items: [
        { name: 'ユーザー管理', to: '/users', icon: Users },
        { name: 'グループ管理', to: '/groups', icon: UserSquare },
        { name: '設定', to: '/settings', icon: Settings },
      ],
    },
  ]

  return (
    <aside
      className={`fixed inset-y-0 left-0 z-50 w-64 bg-white dark:bg-gray-800 border-r border-gray-200 dark:border-gray-700 transform transition-transform duration-200 ease-in-out ${
        sidebarOpen ? 'translate-x-0' : '-translate-x-full'
      }`}
    >
      <div className="flex flex-col h-full">
        {/* ロゴ */}
        <div className="flex items-center gap-3 px-6 py-5 border-b border-gray-200 dark:border-gray-700">
          <div className="w-10 h-10 bg-gradient-to-br from-blue-600 to-blue-700 rounded-xl flex items-center justify-center shadow-lg">
            <Phone className="w-6 h-6 text-white" />
          </div>
          <div>
            <h1 className="text-lg font-bold text-gray-900 dark:text-white">
              ガンモ
            </h1>
            <p className="text-xs text-gray-500 dark:text-gray-400">
              Contact Center
            </p>
          </div>
        </div>

        {/* ナビゲーション */}
        <nav className="flex-1 px-3 py-4 overflow-y-auto">
          {navigationSections.map((section) => (
            <div key={section.label} className="mb-4">
              <p className="px-4 pt-2 pb-1 text-xs font-semibold text-gray-400 dark:text-gray-500 uppercase tracking-wider">
                {section.label}
              </p>
              <div className="space-y-1">
                {section.items.map((item) => (
                  <NavLink
                    key={item.to}
                    to={item.to}
                    end={item.to === '/'}
                    className={({ isActive }) =>
                      `flex items-center gap-3 px-4 py-2.5 rounded-xl transition-all duration-200 ${
                        isActive
                          ? 'bg-gradient-to-r from-blue-50 to-blue-100 dark:from-blue-900/30 dark:to-blue-800/30 text-blue-700 dark:text-blue-300 shadow-sm font-semibold'
                          : 'text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700/50 font-medium'
                      }`
                    }
                  >
                    <item.icon className="w-5 h-5 flex-shrink-0" />
                    <span>{item.name}</span>
                    {item.to === '/line-chat' && lineUnreadCount > 0 && (
                      <span className="ml-auto w-5 h-5 bg-green-500 text-white text-xs font-bold rounded-full flex items-center justify-center flex-shrink-0">
                        {lineUnreadCount > 99 ? '99+' : lineUnreadCount}
                      </span>
                    )}
                  </NavLink>
                ))}
              </div>
            </div>
          ))}
        </nav>

        {/* ユーザー情報 */}
        <div className="px-3 py-4 border-t border-gray-200 dark:border-gray-700">
          <div className="flex items-center gap-3 px-3 py-2 mb-2 bg-gray-50 dark:bg-gray-700/50 rounded-xl">
            <div className="w-10 h-10 bg-gradient-to-br from-gray-300 to-gray-400 dark:from-gray-600 dark:to-gray-700 rounded-full flex items-center justify-center shadow-sm">
              <span className="text-sm font-bold text-gray-700 dark:text-gray-200">
                {user?.email?.[0].toUpperCase()}
              </span>
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-semibold text-gray-900 dark:text-white truncate">
                {user?.email}
              </p>
              <p className="text-xs text-gray-500 dark:text-gray-400">
                {roleLabel}
              </p>
            </div>
          </div>
          <button
            onClick={logout}
            className="flex items-center gap-2 w-full px-4 py-2.5 text-sm font-medium text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/20 rounded-xl transition-colors"
          >
            <LogOut className="w-4 h-4" />
            <span>ログアウト</span>
          </button>
        </div>
      </div>
    </aside>
  )
}
